import { gsap } from "gsap";
import Swiper from 'swiper';
import { A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/a11y';
import '../../css/share/common.scss';
import './layout/_header';
import { lazyload } from "./components/_lazyload.js";
import '../share/components/_lightbox';

$(function () {


    let _search_o = true;
    const $nav_list = $('.nav_list');
    $('.icon_search').click(function () {
        if (_search_o) {
            $nav_list.addClass('search_active');
            _search_o = false;
        } else {
            $nav_list.removeClass('search_active');
            _search_o = true;
        }
    });
    $('.header_search_row').focusin(function () {
        $nav_list.addClass('search_active');
        _search_o = false;
    });
    $('.header_search_row').focusout(function () {
        $nav_list.removeClass('search_active');
        _search_o = true;
    });


    if ($(".sponsor_swiper").length > 0) {

        const $swiper = '.sponsor_swiper';
        const container = $swiper + ' .swiper';
        const pagination = $swiper + ' .swiper-pagination';
        const button_next = $swiper + ' .swiper-button-next';
        const button_prev = $swiper + ' .swiper-button-prev';

        const mySwiper = new Swiper(container, {
            modules: [A11y],
            grabCursor: true,
            slidesPerView: 'auto',
            // centeredSlides: true,
            // loop: true,
            // speed: 400,
            // autoplay: {
            //     delay: 2000,
            // },
            pagination: {
                el: pagination,
                clickable: true,
            },
            navigation: {
                nextEl: button_next,
                prevEl: button_prev,
            },
            a11y: {
                enabled: true,
                firstSlideMessage: "第一則",
                lastSlideMessage: "最後一則",
                paginationBulletMessage: "到第 {{index}} 則",
            },
        });
    }

    let _hash;
    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });

    $('.backtotop').click(function (e) {
        e.preventDefault();
        gsap.to('html, body', {
            duration: 1,
            scrollTop: 0,
            ease: 'quart.out'
        });
    });

    //--------------------- imagesLoaded ---------------------//
    function removeLoading() {
        $(".loading").fadeOut(function () {
            $(this).remove();
        });
    }

    imagesLoaded("html, body", function () {
        removeLoading();
        lazyload();
        $('head').append('<link rel="stylesheet" href="/2023/css/common_lazy.min.css">')
        if ($('.tw').length > 0) {
            $('head').append('<link rel="stylesheet" href="/2023/css/lang_tw.min.css">')
        } else {
            $('head').append('<link rel="stylesheet" href="/2023/css/lang_en.min.css">')
        }
    });
});